import React from 'react';
import { Row } from 'react-bootstrap';
import { HappContainer } from 'happ-components/HappStyledComponents/HappContainer/HappContainer';
import WhatsAppButtonIcon from 'happ-components/WhatsAppButtonIcon/WhatsAppButtonIcon';
import logo from 'assets/imgs/imag_.png';
import './index.css';

const SsoSamlUserNotFound = () => {
    return (
        <Row className="mt-content ">
            <HappContainer>
                <>
                    <div className='text-center mt-5 mb-3 content-not-fount-sso'>
                        <div className="mb-3 mt-md-4 content-logo-sso">
                            <div className="content-logo logo-login mt-3">
                                <img src={logo} alt="description" />
                            </div>
                        </div>
                        <h5>No pudiste entrar a la plataforma happ, no estas enrolado.</h5>
                        <h5>Contacta a soporte de happ para habilitar tu cuenta.</h5>
                        <div className='mt-3'>
                            <WhatsAppButtonIcon
                                view={'sso-saml-view'}
                            />
                        </div>
                    </div>
                </>
            </HappContainer>
        </Row>
    );
}

export default SsoSamlUserNotFound;